<template>
  <el-drawer
    title="版本记录"
    :visible.sync="showDrawer"
    :size="400"
    :modal="direction==='ltr'"
    :append-to-body="direction==='ltr'"
    :direction="direction"
  >
    <div class="data-version-container">
      <div class="top-content">
        <div class="title-container">
          <img class="file-img" :src="getFileIcon(details.suffix)" style="margin-right: 6px;">
          <div class="title-info">{{ data.fileName }}.{{ details.suffix }}</div>
        </div>
        <div class="version-info">路径： {{ getFilePath }}</div>
      </div>
      <data-version-info
        v-if="data.revisionRecords && data.revisionRecords.length"
        :dataVersionList="data.revisionRecords"
        :permissionType="data.permissionType"
        :space-id="spaceId"
        :fileId="data.fileId"
        :btnObj="btnObj"
        @version-changed="versionChanged"
        @view-3d="toView"
        @download="downloadTrack"
        @onLink="$emit('onLink', details)"
        @onImport="$emit('onImport', details)"/>
    </div>
  </el-drawer>
</template>

<script>
import { mapGetters } from 'vuex'
import DataVersionInfo from './DataVersionInfo.vue'
export default {
  name: 'DataVersionRecord',
  components: { DataVersionInfo },
  props: {
    direction: {
      type: String,
      default: 'rtl'
    },
  },
  data() {
    return {
      showDrawer: false,
      data: {},
      spaceId: '',
      details: {},
      btnObj: {}
    }
  },
  computed: {
    ...mapGetters({
      currentResource: 'resourceDetail/currentResource',
      clientType: 'platform',
    }),
    getFilePath() {
      const names = this.data.paths?.map((item) => item.name)
      return names?.join('/')
    },
    getFileIcon() {
      return (type) => require(`@/assets/file/${type || 'default'}.png`)
    }
  },
  methods: {
    openDrawer(data, spaceId, item, btnObj) {
      this.showDrawer = true
      this.data = {
        ...data,
        revisionRecords: data.revisionRecords.reverse()
      }
      this.spaceId = spaceId
      this.details = item
      this.btnObj = btnObj
      this.$tracks({
        event: 'visitSpaceProfileVersionHistory',
        params: {
          g_c_space_id: this.spaceId,
          g_c_file_id: data.fileId,
        }
      })
    },
    versionChanged() {
      this.$emit('version-changed', this.details, 'refreshList')
    },
    // 查看轻量化
    toView(item) {
      if (item.fileRevisionId) {
        // 跳转到查看页
        this.$tracks({
          event: '3DViewSpaceProfile',
          params: {
            g_c_space_id: this.spaceId,
            g_c_file_id: this.data.fileId,
          }
        })
        const ModelViewPage = this.$router.resolve({
          name: 'FileModelView',
          params: { spaceId: this.spaceId, fileId: this.data.fileId },
          query: {
            fileVersionId: item.fileRevisionId,
            title: `${this.data.fileName}.${this.details.suffix}`,
            version: item.version
          },
        })
        const url = `${process.env.VUE_APP_PROJECT_HOST}${ModelViewPage.href}`
        if (this.clientType === 'web') {
          window.open(url, '_blank')
        } else {
          this.$desktopClient.NavigateToBrowser(url)
        }
      }
    },
    // 下载埋点
    downloadTrack() {
      this.$tracks({
        event: 'downloadSpaceProfile',
        params: {
          g_c_space_id: this.spaceId,
          g_c_file_id: this.details.id,
        }
      })
    }
  },
}
</script>

<style lang="less" scoped>
.data-version-container{
  padding: 20px 0;
}
.top-content{
  padding: 0 16px;
  .title-container {
    display: flex;
    .file-img {
      width: 20px;
      height: 20px;
    }
  }
}
.title-info{
  color: @text-title-gery;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 16px;
}
.version-info{
  color: @text-sub-gery;
  margin-bottom: 20px;
}
</style>
